export default __webpack_public_path__ + "static/media/undraw_Newsletter_re_wrob.0b4feca7.svg";